import * as constants from './constants'

export const sendRoomState = (
    sendSocketMessage,
    state = constants.VIDEO_CALL
) => {
    if (!sendSocketMessage) return
    sendSocketMessage(JSON.stringify({ action: constants.ROOM_STATE, state }))
}
